module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Spectrum Peak Frequency","subTitle":"Frequency corresponding to the peak of the maximum amplitude spectrum."},"it":{"title":"Frequenza del picco dello spettro","subTitle":"Frequenza corrispondente al picco dello spettro di massima ampiezza."}}')
  delete Component.options._Ctor
}
